<div class="auth-page">
  <div class="auth-card">
    <h1 class="auth-heading">Welcome to Proximity.</h1>
    <p class="auth-subtitle">Sign in to securely access your account.</p>

    <form name="loginForm" #form="ngForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-4">
        <input pInputText id="username" placeholder="Username or Email" [(ngModel)]="username" required name="username"
          [pAutoFocus]="true" class="w-full" />
        <p-password [(ngModel)]="password" [toggleMask]="true" required name="password" placeholder="Password"
          [feedback]="false" styleClass="w-full"></p-password>
        <button pButton label="Continue" type="submit" [disabled]="form.invalid" [loading]="working"
          class="w-full mt-2"></button>
      </div>

      @if (error) {
        <p class="text-center mt-3 mb-0" [class.text-red-500]="!errorIsSoft" [class.text-orange-500]="errorIsSoft">{{error}}</p>
      }
      @if (success) {
        <p class="text-green-500 text-center mt-3 mb-0">{{success}}</p>
      }
    </form>

    <div class="text-center mt-4">
      <a routerLink="/auth/forgot-password" class="text-primary font-medium hover:underline">Forgot password?</a>
    </div>

    <div class="auth-divider mt-6 mb-4">or</div>

    <p class="text-center text-sm text-gray-600 mb-0">
      Unable to access Proximity? <a routerLink="/auth/contact-us" class="text-primary font-medium hover:underline">Click here</a> and let
      us help you.
    </p>
  </div>
</div>
